import { useSimulatorRouteConfig } from "@hooks/useSimulatorRouteConfig";
import { Box } from "@mui/material";
import ViewFallback from "@views/ViewFallback";
import { useMemo } from "react";
import { Route, Routes } from "react-router-dom";

const ViewSimulator = () => {
  const simulatorRoutes = useSimulatorRouteConfig();

  const routes = useMemo(() => {
    return simulatorRoutes.map((route) => (
      <Route path={route.path} Component={route.component} key={route.path} />
    ));
  }, [simulatorRoutes]);

  return (
    <Box>
      <Routes>
        {routes}
        {/* Not found page */}
        <Route path="*" element={<ViewFallback variant="not-found" />} />
      </Routes>
    </Box>
  );
};

export default ViewSimulator;
